import { MODULE_NAME } from './const';
import {
	SET_DID_SEE_UTM_INTRO,
	SET_IS_PROJECT_MENU_PINNED,
	SET_IS_NOTIFICATIONS_PINNED,
	SET_SHOW_INSPIRATION_CENTER,
	SET_SEEN_INTERFACE_EXPLANATION,
	SET_DISMISSED_SPACE_TAB_EXPLANATION,
	SET_DISMISSED_PLACEMENT_TAB_EXPLANATION,
} from './mutations';
import StoreModuleService from '../StoreModuleService';
const buildAppLayoutActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);
// actions declarations
export const setDidSeeUtmIntro = buildAppLayoutActionObject('setDidSeeUtmIntro');
export const setIsProjectMenuPinned = buildAppLayoutActionObject('setIsProjectMenuPinned');
export const setIsNotificationsPinned = buildAppLayoutActionObject('setIsNotificationsPinned');
export const setShowInspirationCenter = buildAppLayoutActionObject('setShowInspirationCenter');
export const setSeenInterfaceExplanation = buildAppLayoutActionObject('setSeenInterfaceExplanation');
export const setDismissedSpaceTabExplanation = buildAppLayoutActionObject('setDismissedSpaceTabExplanation');
export const setDismissedPlacementTabExplanation = buildAppLayoutActionObject('setDismissedPlacementTabExplanation');
const actions = {
	...StoreModuleService.createDefaultActions(),
	[setIsProjectMenuPinned.action]({ commit }, { isPinned }) {
		commit(SET_IS_PROJECT_MENU_PINNED, isPinned);
	},
	[setIsNotificationsPinned.action]({ commit }, { isPinned }) {
		commit(SET_IS_NOTIFICATIONS_PINNED, isPinned);
	},
	[setDismissedSpaceTabExplanation.action]({ commit }, { dismissed }) {
		commit(SET_DISMISSED_SPACE_TAB_EXPLANATION, dismissed);
	},
	[setDismissedPlacementTabExplanation.action]({ commit }, { dismissed }) {
		commit(SET_DISMISSED_PLACEMENT_TAB_EXPLANATION, dismissed);
	},
	[setShowInspirationCenter.action]({ commit }, { showInspirationCenter }) {
		commit(SET_SHOW_INSPIRATION_CENTER, showInspirationCenter);
	},
	[setSeenInterfaceExplanation.action]({ commit }, { seenInterfaceExplanation }) {
		commit(SET_SEEN_INTERFACE_EXPLANATION, seenInterfaceExplanation);
	},
	[setDidSeeUtmIntro.action]({ commit }, { didSeeUtmIntro }) {
		commit(SET_DID_SEE_UTM_INTRO, didSeeUtmIntro);
	},
};

export default actions;
